import React from 'react'
import { AppLayout } from 'layouts'
import { 
    Box, 
    Link, 
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper
} from '@mui/material'


const disseminationList = [
    {
        text: 'Public Deliverables',
        link: '#',
    },
    {
        text: 'Journal Papers',
        link: '#',
    },
    {
        text: 'Conference Papers',
        link: '#',
    },
]

const papersList = [
    {
        id: 1,
        authors: 'Yingzhuo Sun, Yulan Gao, Ming Xiao, Zhu Han, Octavia A. Dobre',
        paper: 'Visibility-aware Satellite Selection and Resource Allocation in Multi-Orbit LEO Networks',
        venue: 'IEEE Transactions on Communication',
        status: 'Submitted',
        link: 'https://www.arxiv.org/abs/2511.12678',
    },
    {
        id: 2,
        authors: 'Zia Nasir, A. Kose, B. Ozbek',
        paper: 'Age of Information-based Approach for Real-Time Anomaly Detection in Communication Networks',
        venue: 'IEEE VTC 2026',
        status: 'Submitted',
        link: '#',
    },
    {
        id: 3,
        authors: 'Purna Sai Garigipati, Onur Ayan, Kishor Chandra Joshi, Xueli An',
        paper: 'Tool Use as Action: Rethinking Network Control via Agentic AI in Mobile Networks',
        venue: 'EuCNC/6G Summit 2026',
        status: 'Submitted',
        link: '#',
    },
    {
        id: 4,
        authors: 'Nooruddin, Mário Antunes, Daniel Corujo, Francisco J. Ferrão',
        paper: 'Anomaly Detection in Imbalanced Cellular Networks via Transfer Learning',
        venue: '-',
        status: 'Submitted',
        link: '#',
    },
    {
        id: 5,
        authors: 'Ishtiaque Ahmed, Leila Musavian',
        paper: 'Hybrid NOMA Assisted Heterogeneous Semantic and Bit Users Communication',
        venue: 'IEEE PIMRC 2025, İstanbul, Türkiye',
        status: 'Published',
        link: 'https://doi.org/10.48550/arXiv.2505.03379',
    },
    {
        id: 6,
        authors: 'Ishtiaque Ahmed, Yingzhuo Sun, Jingwen Fu, Alper Kose, Leila Musavian, Ming Xiao, Berna Ozbek',
        paper: 'Semantic Communications in 6G: Coexistence, Multiple Access, and Satellite Networks',
        venue: 'IEEE Communications Standards Magazine, December 2025',
        status: 'Published',
        link: 'https://doi.org/10.48550/arXiv.2506.11779',
    },
    {
        id: 7,
        authors: 'A. Altınoklu, L. Musavian',
        paper: 'Lorentzian-Constrained Holographic Beamforming Optimization in Multi-User Networks With Dynamic Metasurface Antennas',
        venue: 'IEEE Transactions on Wireless Communications, vol. 25, 2026',
        status: 'Published',
        link: 'https://arxiv.org/abs/2505.08356',
    },
    {
        id: 8,
        authors: 'A. M. Nair, S. Mumtaz, C. C. Tsimenidis, F. Doctor, C. Karyotis, R. Iqbal',
        paper: 'Quantum Enabled Temporal Power Smoothing in User Equipment-Radio Unit Allocation for Wireless Systems',
        venue: 'IEEE PIMRC 2025, Istanbul, Turkiye',
        status: 'Published',
        link: '#',
    },
    {
        id: 9,
        authors: 'Onur Ayan, Jiping Luo, Xueli An, Nikolaos Pappas',
        paper: 'Age-Aware CSI Acquisition of a Finite-State Markovian Channel',
        venue: 'IEEE PIMRC 2025, Istanbul, Turkiye',
        status: 'Published',
        link: '#',
    },
    {
        id: 10,
        authors: 'Nooruddin',
        paper: 'Deep learning-based fault detection in cellular networks using RNN and MLP architectures',
        venue: 'Research Summit 2025, University of Aveiro',
        status: 'Published',
        link: '#',
    },
    {
        id: 11,
        authors: 'Akshay Mohan Nair, Shahid Mumtaz, Charalampos C. Tsimenidis, Charalampos Karyotis, Rahat Iqbal',
        paper: 'Quantum Optimised Resource Allocation Algorithm (QOPRA)',
        venue: 'IEEE VTC 2025',
        status: 'Published',
        link: '#',
    },
    {
        id: 12,
        authors: 'Ayesha Jadoon, H. R. Chi, D. Corujo, R. L. Aguiar, F. J. Ferrão',
        paper: 'Latency and Energy Modeling of Blockchain-Digital Twin-Relied Edge Computing Task Scheduling',
        venue: 'IEEE ICCT-Europe 2025, Algarve, Portugal',
        status: 'Published',
        link: '#',
    },
    {
        id: 13,
        authors: 'Ayesha Jadoon, Daniel Corujo, Shahid Mumtaz, Rui Luis Andrade Aguiar',
        paper: 'Integrating digital twin and blockchain technologies for sustainable development',
        venue: 'Research Summit 2025',
        status: 'Published',
        link: 'https://acrobat.adobe.com/id/urn:aaid:sc:eu:a1e99dee-ffeb-4b96-859e-f4778320074b',
    },
    {
        id: 14,
        authors: 'Yingzhuo Sun, Yulan Gao, Ming Xiao, Antoine Honor',
        paper: 'Optimizing Satellite Selection and User Association in Multi-Orbit Satellite Constellations',
        venue: 'IEEE ICC 2025, Canada',
        status: 'Published',
        link: '#',
    },
    {
        id: 15,
        authors: 'Askin Altinoklu, Leila Musavian',
        paper: 'Investigation of Holographic Beamforming via Dynamic Metasurface Antennas in QoS Guaranteed Power Efficient Networks',
        venue: 'EuCNC & 6G Summit 2025',
        status: 'Published',
        link: 'https://arxiv.org/abs/2411.05659',
    },
    {
        id: 16,
        authors: 'Babak Azkaei, Kishor Joshi, George Exarchakos',
        paper: 'Machine Learning-Driven Anomaly Detection for 5G O-RAN Performance Metrics',
        venue: 'IEEE INFOCOM 2025, London, UK',
        status: 'Published',
        link: 'https://arxiv.org/pdf/2509.03290',
    },
    {
        id: 17,
        authors: 'Y. Zhou, Y. Wang, Z. Ma, P. Fan, M. Xiao',
        paper: 'Physical Layer Authentication for UAV Communications Under Rayleigh and Rician Channels',
        venue: 'IEEE Trans. Wireless Commun., vol. 24, no. 4, April 2025',
        status: 'Published',
        link: 'https://doi.org/10.1109/TWC.2024.3524210',
    },
    {
        id: 18,
        authors: 'Cheng Zeng, Jun-Bo Wang, Ming Xiao, Changfeng Ding, Yijian Chen, Hongkang Yu',
        paper: 'Task-Oriented Semantic Communication over Rate Splitting Enabled Wireless Control Systems for URLLC Services',
        venue: 'IEEE Trans. Commun., vol. 72, no. 2, Feb. 2024',
        status: 'Published',
        link: '#',
    },
    {
        id: 19,
        authors: 'Sicong Ye, D. Zhang, M. Xiao, M. Skoglund',
        paper: 'Integrated Communication and Computation Empowered by Fluid Antenna Array',
        venue: 'IEEE SPAWC 2024, Italy',
        status: 'Published',
        link: '#',
    },
    {
        id: 20,
        authors: 'Ayesha Jadoon, Rui Aguiar, Daniel Corujo, Francisco Ferrao',
        paper: 'A Comparative Analysis of Random Forest and Multilayer Perceptron Approaches for Classification of IoT Devices',
        venue: 'INForum 2024, Lisbon, Portugal',
        status: 'Published',
        link: 'https://arxiv.org/pdf/2410.03732',
    },
    {
        id: 21,
        authors: 'Ayesha Jadoon, Daniel Corujo, Shahid Mumtaz, Rui Luis Andrade Aguiar',
        paper: 'Block Chain Modelling and Optimization for Intelligent Digital Twin',
        venue: 'Research Summit 2024',
        status: 'Published',
        link: '#',
    },
    {
        id: 22,
        authors: 'Nooruddin, Daniel Corujo, Rui L. Aguiar, Francisco J. Ferrão',
        paper: 'Multi-Scale Convolutional LSTM with Transfer Learning for Anomaly Detection in Cellular Networks',
        venue: 'INForum 2024, Lisboa, Portugal',
        status: 'Published',
        link: 'https://arxiv.org/pdf/2410.03732',
    },
    {
        id: 23,
        authors: 'Nooruddin, Daniel Corujo, Rui L. Aguiar, Francisco J. Ferrão',
        paper: 'The use of transfer learning based framework for fault forecasting in cellular Networks',
        venue: 'Research Summit 2024',
        status: 'Published',
        link: '#',
    },
]


const Dissemination = () => {
    return (
        <AppLayout>
            {/* <Typography
                sx={{
                    fontFamily: 'Poppins-Semibold',
                    fontSize: '20px',
                    lineHeight: '24px',
                    color: '#222',
                    mb: '20px',
                    textTransform: 'uppercase',
                    textAlign: { xs: 'center', md: 'left' }
                }}
            >
                Dissemination
            </Typography> */}

            {/* <Typography
                sx={{
                    fontFamily: 'Poppins-Regular',
                    fontSize: '16px',
                    lineHeight: '20px',
                    color: '#666',
                    mb: '20px',
                    // textAlign: { xs: 'center', md: 'left' }
                }}
            >
                You can examine and download public documents and results of SCION as above:
            </Typography> */}

            {/* <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '10px',
                    mb: '30px',
                }}
            >
                {
                    disseminationList?.map((item, index) => {

                        return (
                            <Link
                                key={index}
                                href={item.link}
                                sx={{
                                    fontFamily: 'Poppins-Medium',
                                    fontSize: '16px',
                                    lineHeight: '20px',
                                    color: '#000',
                                }}
                            >
                                {item?.text}
                            </Link>
                        )
                    })
                }
            </Box> */}

            <Typography
                sx={{
                    fontFamily: 'Poppins-Semibold',
                    fontSize: '18px',
                    lineHeight: '22px',
                    color: '#222',
                    mb: '20px',
                    textAlign: { xs: 'center', md: 'left' }
                }}
            >
                PUBLICATIONS
            </Typography>

            <TableContainer component={Paper} sx={{ mb: '50px' }}>
                <Table sx={{ minWidth: 650 }} aria-label="publications table">
                    <TableHead>
                        <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                            <TableCell 
                                sx={{ 
                                    fontFamily: 'Poppins-Semibold',
                                    fontSize: '14px',
                                    fontWeight: 'bold'
                                }}
                            >
                                #
                            </TableCell>
                            <TableCell 
                                sx={{ 
                                    fontFamily: 'Poppins-Semibold',
                                    fontSize: '14px',
                                    fontWeight: 'bold'
                                }}
                            >
                                Authors
                            </TableCell>
                            <TableCell 
                                sx={{ 
                                    fontFamily: 'Poppins-Semibold',
                                    fontSize: '14px',
                                    fontWeight: 'bold'
                                }}
                            >
                                Paper
                            </TableCell>
                            <TableCell 
                                sx={{ 
                                    fontFamily: 'Poppins-Semibold',
                                    fontSize: '14px',
                                    fontWeight: 'bold'
                                }}
                            >
                                Published In
                            </TableCell>
                            <TableCell 
                                sx={{ 
                                    fontFamily: 'Poppins-Semibold',
                                    fontSize: '14px',
                                    fontWeight: 'bold'
                                }}
                            >
                                Status
                            </TableCell>
                            <TableCell 
                                sx={{ 
                                    fontFamily: 'Poppins-Semibold',
                                    fontSize: '14px',
                                    fontWeight: 'bold'
                                }}
                            >
                                Link
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {papersList.map((paper) => (
                            <TableRow
                                key={paper.id}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell 
                                    component="th" 
                                    scope="row"
                                    sx={{ 
                                        fontFamily: 'Poppins-Regular',
                                        fontSize: '14px'
                                    }}
                                >
                                    {paper.id}
                                </TableCell>
                                <TableCell 
                                    sx={{ 
                                        fontFamily: 'Poppins-Regular',
                                        fontSize: '14px'
                                    }}
                                >
                                    {paper.authors}
                                </TableCell>
                                <TableCell 
                                    sx={{ 
                                        fontFamily: 'Poppins-Regular',
                                        fontSize: '14px'
                                    }}
                                >
                                    {paper.paper}
                                </TableCell>
                                <TableCell 
                                    sx={{ 
                                        fontFamily: 'Poppins-Regular',
                                        fontSize: '13px',
                                        fontStyle: 'italic',
                                        color: '#555'
                                    }}
                                >
                                    {paper.venue}
                                </TableCell>
                                <TableCell 
                                    sx={{ 
                                        fontFamily: 'Poppins-Regular',
                                        fontSize: '14px',
                                        color: paper.status === 'Published' ? '#4caf50' : 
                                               paper.status === 'Accepted' ? '#2196f3' :
                                               paper.status === 'Submitted' ? '#ff9800' : '#666'
                                    }}
                                >
                                    {paper.status}
                                </TableCell>
                                <TableCell 
                                    sx={{ 
                                        fontFamily: 'Poppins-Regular',
                                        fontSize: '14px'
                                    }}
                                >
                                    {paper.link !== '#' ? (
                                        <Link 
                                            href={paper.link} 
                                            target="_blank" 
                                            rel="noopener noreferrer"
                                            sx={{
                                                color: '#1976d2',
                                                textDecoration: 'none',
                                                '&:hover': {
                                                    textDecoration: 'underline'
                                                }
                                            }}
                                        >
                                            View Paper
                                        </Link>
                                    ) : (
                                        <Typography 
                                            sx={{ 
                                                fontSize: '14px',
                                                color: '#999'
                                            }}
                                        >
                                            -
                                        </Typography>
                                    )}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

        </AppLayout>
    )
}

export default Dissemination